"use client";

import { useState } from "react";

/**
 * Share row for a note. X + LinkedIn are plain intent links (work without JS);
 * copy-link uses the clipboard API with a brief confirmation. `url` is absolute.
 */
export function ShareButtons({ url, title }: { url: string; title: string }) {
  const [copied, setCopied] = useState(false);

  const x = `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`;
  const linkedin = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;

  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch {
      /* clipboard blocked — the X/LinkedIn links still work */
    }
  }

  const cls =
    "inline-flex items-center gap-2 rounded-md border border-[var(--color-hairline)] px-3 py-2 microcaps text-[var(--color-text-dim)] transition-colors hover:border-[var(--color-hairline-strong)] hover:text-[var(--color-text)]";

  return (
    <div className="flex flex-wrap items-center gap-3">
      <span className="microcaps text-[var(--color-text-mute)]">Share</span>
      <a href={x} target="_blank" rel="noopener noreferrer" className={cls} aria-label="Share on X">
        X
      </a>
      <a href={linkedin} target="_blank" rel="noopener noreferrer" className={cls} aria-label="Share on LinkedIn">
        LinkedIn
      </a>
      <button type="button" onClick={copy} className={cls} aria-live="polite">
        {copied ? "Copied ✓" : "Copy link"}
      </button>
    </div>
  );
}
